/**
 *
 * @module gamedayLauncher/configs
 *
 */

/* global module */

(function(root, factory) {

    if (typeof define === 'function' && define.amd) {
        define('gamedayLauncher/configs',[], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.bamGamedayLauncherConfigs = factory();
    }

}(this, function() {

    'use strict';

    var exports = {};

    exports.versions = {
        '2005': {
            url: '/mlb/gameday/gd2005.html?',
            options: 'location=no,menubar=no,scrollbars=no,status=no,toolbar=no,resizable=yes',
            w: 770,
            h: 600
        },
        '2005_milb': {
            url: 'http://www.milb.com/milb/gameday/y2005/gdmilb.html?',
            options: 'location=no,menubar=no,scrollbars=no,status=no,toolbar=no,resizable=yes',
            w: 770,
            h: 600
        },
        '2006': {
            url: '/mlb/gameday/y2006/gd.html?',
            options: 'location=no,menubar=no,scrollbars=no,status=no,toolbar=no,resizable=yes',
            w: 770,
            h: 600
        },
        '2007_milb': {
            url: 'http://www.milb.com/milb/gameday/y2007/gd.html?',
            options: 'location=no,menubar=no,scrollbars=no,status=no,toolbar=no,resizable=yes',
            w: 980,
            h: 600
        },
        '2007': {
            url: '/mlb/gameday/y2007/gd.html?',
            options: 'location=no,menubar=no,scrollbars=no,status=no,toolbar=no,resizable=yes',
            w: 980,
            h: 600
        },
        'v4': {
            url: '/mlb/gameday/y2009/index.jsp?gid=',
            w: 990,
            h: 576
        },
        'v4_mini': {
            url: '/mlb/gameday/mini.jsp?gid=',
            options: 'location=no,menubar=no,scrollbars=no,status=no,toolbar=no,resizable=yes',
            w: 300,
            h: 368
        },
        'v5': {
            url: 'http://www.mlb.com/r/game?gid=',
            w: 990,
            h: 576
        },
        'v6_wbc2013': {
            url: '/wbc/2013/gameday/index.jsp?gid=',
            w: 990,
            h: 576
        }
    };

    exports.inferVersion = function( params, gid ) {
        var year = gid.substring( 0, 4 );
        year = +year;

        var isMilb = ('sport_code' in params) && params.sport_code !== 'mlb' && params.sport_code !== 'int';

        switch( true ) {
            case params.mode === 'mini' && (year === 2008 || year === 2009):
                return 'v4_mini';

            case year === 2012 && params.sport_code === 'int':
                case year === 2013 && params.sport_code === 'int':
                return 'v6_wbc2013'; 

            case year >= 2010 || year <= 2000:
                return 'v5';

            case year === 2009:
                case year === 2008:
                return 'v4';

            case year === 2005 && isMilb:
                case year === 2007 && isMilb:
                return year.toString()+'_milb';

            default:
                return year.toString();
        }
    };

    exports.getWindowName = function( version, gid ) {

        switch( version ) {
            case '2005':
                case '2006':
                case '2007':
                return 'GamedayWin';

            case 'v4_mini':
                return 'gdmini_'+gid;

            default:
                return 'gd_'+gid;
        }
    };

    exports.shouldUsePopup = function( version, params ) {
        switch( true ) {
            case params.mode === 'preview':
                case version === 'v5':
                case version === 'v6_wbc2013':
                return false;

            default:
                return true;


        }
    };

    return exports;

}));

